export const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
